import type { TextareaProps } from '@chakra-ui/react'
import { Textarea } from '@chakra-ui/react'
import React from 'react'
import { withFormControl, type FormFieldProps } from './hoc/withFormControl'

// Component-specific props
export interface TextareaFormControlComponentProps {
  placeholder?: string
  maxLength?: number
  rows?: TextareaProps['rows']
  resize?: TextareaProps['resize']
  variant?: TextareaProps['variant']
  w?: TextareaProps['w']
  textareaProps?: Omit<TextareaProps, 'value' | 'onChange' | 'onBlur' | 'name' | 'isDisabled' | 'placeholder' | 'maxLength' | 'rows' | 'variant' | 'w'>
}

// Base component that handles textarea logic
export const TextareaFormControlBase = React.forwardRef<
  HTMLTextAreaElement,
  TextareaFormControlComponentProps & FormFieldProps<string | null, HTMLTextAreaElement>
>((props, ref) => {
  const {
    // Form field props
    value,
    onChange,
    onBlur,
    isDisabled,
    name,
    // Component-specific props
    placeholder,
    maxLength,
    rows,
    resize,
    variant,
    textareaProps
  } = props

  return (
    <Textarea
      ref={ref}
      name={name}
      value={value ?? ''}
      onChange={(e) => {
        const newValue = e.target.value
        // Transform empty string to null
        onChange(newValue === '' ? null : newValue)
      }}
      onBlur={onBlur}
      isDisabled={isDisabled}
      placeholder={placeholder}
      maxLength={maxLength}
      rows={rows}
      resize={resize}
      variant={variant}
      w="full"
      {...textareaProps}
    />
  )
});

(TextareaFormControlBase as any).displayName = 'TextareaFormControlBase'

// Export the wrapped component
export const TextareaFormControl = withFormControl<TextareaFormControlComponentProps, string | null, HTMLTextAreaElement>(TextareaFormControlBase)